import React from 'react';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';

import Dashboard from './components/Dashboard/Dashboard';

const App = () => {
  const theme = extendTheme({
    styles: {
      global: {
        body: {
          bg: "#0d131c",
          color: "#FFFFFF",
          fontFamily: 'Jost',
        },
      },
    }, 
    components: { 
      Button: { 
        baseStyle: { 
          _focus: { 
            boxShadow: 'none' 
          } 
        } 
      },
      Divider: {
        baseStyle: {
          borderBottomWidth: "2px",
          borderColor: "#E1B752",
          transform: "translateX(-30px)"
        }
      },
      Link: {
        baseStyle: {
          _hover: {
            textDecoration: "none"
          }
        }
      },
    } 
  });

  return (
    <ChakraProvider theme={theme}>
      <Dashboard />
    </ChakraProvider>
  );
}

export default App;

